export const contactContent = {
  title: '联系我们',
  phone: '400-000-0000',
  phoneLabel: '服务热线',
  qrcode: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/39fb5e8f2e5d65a608fc0ca9cbb153ec.jpeg',
  qrcodeLabel: '企业微信',
  qrcodeTip: '扫码添加企业微信，获取专属服务',
};